import getIn from 'transmute/getIn';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropertyEditCell from 'framework-data-table/contentRenderers/properties/PropertyEditCell';
import { updateDealProperty } from '../../actions/StagedDealsUpdatesActions';
import { setDealValidation } from '../../actions/DealValidationActions';
import { getDealPropertyValidation } from '../../selectors/dealValidationSelectors';
import { getStagedDealsUpdates } from '../../selectors/stagedDealsUpdatesSelectors';
import { getProperties } from '../../selectors/properties';
import { DEAL_OBJECT_ID } from '../../constants/CrmSearchConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyEditCellWrapper = ({
  row,
  columnName,
  requiredCellProps
}) => {
  const dispatch = useDispatch();
  const dealProperty = row.properties[columnName];
  const propertyDefinition = useSelector(getProperties)[columnName];
  const value = dealProperty ? dealProperty.value : undefined;
  const dealValidation = useSelector(getDealPropertyValidation(row.id, columnName));
  const canEditObject = Boolean(getIn(['currentUserPermissions', 'canEdit'], row));
  const stagedDealUpdates = useSelector(getStagedDealsUpdates)[row.id];
  const stagedValue = stagedDealUpdates && stagedDealUpdates[columnName];
  const doesPropertyHaveStagedValue = stagedDealUpdates && columnName in stagedDealUpdates;
  const liveValue = doesPropertyHaveStagedValue ? stagedValue : value;
  const onPropertyUpdates = useCallback(({
    objectId,
    values
  }) => {
    Object.keys(values).forEach(property => {
      const newValue = values[property];
      return dispatch(updateDealProperty({
        dealId: objectId,
        property,
        value: newValue
      }));
    });
  }, [dispatch]);
  const onValidationChange = useCallback(validationState => dispatch(setDealValidation(row.id, columnName, validationState)), [columnName, dispatch, row]);

  // Fetches the most recent value of other properties in the row (even if not saved)
  const getSecondaryPropertyValue = useCallback(propertyName => {
    const hasDraft = stagedDealUpdates && stagedDealUpdates[propertyName];
    if (hasDraft) {
      return stagedDealUpdates[propertyName];
    }
    return getIn(['properties', propertyName, 'value'], row) || undefined;
  }, [stagedDealUpdates, row]);
  return /*#__PURE__*/_jsx(PropertyEditCell, {
    objectTypeId: DEAL_OBJECT_ID,
    objectId: row.id,
    originalValue: value,
    value: liveValue,
    validationResult: dealValidation,
    propertyDefinition: propertyDefinition,
    getSecondaryPropertyValue: getSecondaryPropertyValue,
    requiredCellProps: requiredCellProps,
    canEditObject: canEditObject,
    onPropertyUpdates: onPropertyUpdates,
    onValidationChange: onValidationChange,
    enableConditionalPropertiesPanel: true,
    enableConditionalPropertyOptions: true
  });
};
export default PropertyEditCellWrapper;